import request from "@/service";

// 评论分页
export function commentPage(data) {
  return request({
    url: `/resource/comment/config/page`,
    method: "get",
    params: data
  });
}

// 评论详情
export function commentInfo(id) {
  return request({
    url: `/resource/comment/config/info/${id}`,
    method: "get"
  });
}

/* 新增 */
export function commentSave(data) {
  return request({
    url: `/resource/comment/config/save`,
    method: "post",
    data
  });
}

/* 修改 */
export function commentUpdate(data) {
  return request({
    url: `/resource/comment/config/update`,
    method: "put",
    data
  });
}

/* 显示隐藏 */
export function commentDisplay(data) {
  return request({
    url: `/resource/comment/config/display`,
    method: "put",
    data
  });
}

/* 删除回收站评论 */
export function commentRemove(data) {
  return request({
    url: `/resource/comment/config/remove`,
    method: "delete",
    data
  });
}
/* 删除|恢复（回收站 */
export function commentDelete(data) {
  return request({
    url: `/resource/comment/config/delete`,
    method: "delete",
    data
  });
}

// 回收站评论分页
export function recyclePage(data) {
  return request({
    url: `/resource/comment/config/recyclePage`,
    method: "get",
    params: data
  });
}

// 人工复核通过-jcc
export function configtReview(data) {
  return request({
    url: `/resource/comment/config/review`,
    method: "put",
    data
  });
}
